<div (click)="picker.open()">
  <label class="!text-[#6B6B6B] !font-medium !text-[16px]" [ngClass]="labelClass">{{label}}</label>
  <div
    class="min-h-[48px] flex items-center gap-3 w-full rounded-lg border border-[#E6E8E9] bg-white px-4 py-1 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary"
    [ngClass]="inputClass">

    <input [formControl]="control" type="text" readonly class="flex-1 bg-transparent placeholder-[#D8D8D8] outline-none"
      [placeholder]=placeholder [matDatepicker]="picker" [min]="minDate" [max]="maxDate" />
    <mat-datepicker #picker></mat-datepicker>
    <div>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.33203 1.33203V3.33203" stroke="#59656F" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M10.668 1.33203V3.33203" stroke="#59656F" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M2.33203 6.05859H13.6654" stroke="#59656F" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M14 5.66536V11.332C14 13.332 13 14.6654 10.6667 14.6654H5.33333C3 14.6654 2 13.332 2 11.332V5.66536C2 3.66536 3 2.33203 5.33333 2.33203H10.6667C13 2.33203 14 3.66536 14 5.66536Z"
          stroke="#59656F" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.4625 9.13411H10.4685" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.4625 11.1341H10.4685" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.99764 9.13411H8.00363" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.99764 11.1341H8.00363" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.52889 9.13411H5.53488" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.52889 11.1341H5.53488" stroke="#59656F" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>

  @if (useDefaultError && ((control.touched || control.dirty) && control.invalid)) {
  <p class="text-red-500 text-xs mt-1">
    {{errorMessage}}
  </p>
  }
</div>